import axios from 'axios';
import api, { NEXTJS_API_URL } from './client';

export const clabAPI = {
  dashboard: async () => {
    try {
      // Use Next.js API for dashboard stats
      const response = await axios.get(`${NEXTJS_API_URL}/clab/dashboard`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      // Handle Next.js Laravel-format response and return in expected format
      if (response.data.status === "success") {
        return {
          status: "success",
          data: response.data.data,
        };
      } else {
        return {
          status: "error",
          message: response.data.message || "Failed to load dashboard stats",
        };
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      return {
        status: "error",
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to load dashboard stats",
      };
    }
  },
  getPendingBiodatas: async () => {
    const response = await api.get("/clab/pending-biodatas");
    return response.data;
  },
  approveBiodata: async (id) => {
    const response = await api.post(`/clab/biodatas/${id}/approve`);
    return response.data;
  },
  rejectBiodata: async (id, data) => {
    const response = await api.post(`/clab/biodatas/${id}/reject`, data);
    return response.data;
  },
  grantEditPermission: async (id, data) => {
    const response = await api.post(
      `/clab/biodatas/${id}/grant-edit-permission`,
      data
    );
    return response.data;
  },
  getPendingApplications: async (params = {}) => {
    const response = await api.get("/clab/pending-applications", { params });
    return response.data;
  },
  getAllApplications: async (params = {}) => {
    try {
      // Use Next.js API for selection requests
      const response = await axios.get(
        `${NEXTJS_API_URL}/clab/selection-requests`,
        {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      return {
        status: "success",
        data: response.data,
      };
    } catch (error) {
      console.error("Error fetching selection requests:", error);
      return {
        status: "error",
        message: error.response?.data?.error || error.message,
        data: { data: [], pagination: null },
      };
    }
  },
  approveApplication: async (id, approveData = {}) => {
    // Get current user for reviewedBy field
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const payload = {
      reviewedBy: user.id,
      ...approveData,
    };
    const response = await api.post(
      `/clab/applications/${id}/approve`,
      payload
    );
    return response.data;
  },
  getSelectionRequestCounts: async () => {
    try {
      const response = await axios.get(
        `${NEXTJS_API_URL}/clab/selection-requests/counts`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      return response.data?.data || response.data || {};
    } catch (error) {
      console.error("Error fetching selection request counts:", error);
      return {};
    }
  },
  rejectApplication: async (id, data) => {
    // Get current user for reviewedBy field
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const payload = {
      reviewedBy: user.id,
      rejectionReasonId: data.rejectionReasonId || data.reason_id,
      comments: data.comments || data.remarks,
      ...data,
    };
    const response = await api.post(`/clab/applications/${id}/reject`, payload);
    return response.data;
  },
  rejectApplicationWorker: async (id, data) => {
    const response = await api.post(
      `/clab/application-workers/${id}/reject`,
      data
    );
    return response.data;
  },
  returnWorkerToPool: async (id, data) => {
    const response = await api.post(
      `/clab/application-workers/${id}/return-to-pool`,
      data
    );
    return response.data;
  },
  bulkRejectBiodata: async (data) => {
    const response = await api.post("/clab/biodata-rejections/bulk", data);
    return response.data;
  },

  // Amendment management endpoints
  getAmendedBiodatas: async (params = {}) => {
    const response = await api.get("/clab/amended-biodatas", { params });
    return response.data;
  },

  getAmendmentHistory: async (biodataId) => {
    const response = await api.get(
      `/clab/biodatas/${biodataId}/amendment-history`
    );
    return response.data;
  },
};

// Shortlist API
